import { Select, Space } from "antd";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import preventiviService from "../../../services/preventivi.service";
const { Option } = Select;


function PreventivoTrattamentoSelect({ value, onChange }) {
    const { token, id } = useParams();
    const [trattamentoVal, setTrattamentoVal] = React.useState("");
    const [categories, setCategories] = React.useState([]);

    const fetchCategories = async () => {
        preventiviService.getCategories(token).then(
            (result) => {
                result = result.data;
                var categories_av = [{id_category: 0, descr: "- Qualsiasi -"}];
                result.map((cat) => {
                    if (cat.name) {
                        if (!categories_av.some(obj => obj.descr == cat.descr)) {
                            categories_av.push(cat);
                        }
                    }
                });
                setCategories(categories_av);
            },
            (error) => { }
        );
    };

    React.useEffect(() => {
        setTrattamentoVal(value);
        fetchCategories();
    }, []);

    return (
        <Select
            style={{
                width: 400,
            }}
            placeholder="Seleziona un tipo di trattamento"
            value={trattamentoVal}
            onChange={(e, opt) => {
                setTrattamentoVal({ value: opt.label.props.children })
                onChange(opt.label.props.children)
            }}
            options={categories?.map((cat) => {
                return {
                    value: cat.id_category, label: <>{cat.descr}</>
                };
            })}
        />
    );
}

function PreventivoTrattamento({ trattamento, UpdatePreventivo }) {
    return (
        <div className="flex flex-row items-center gap-2 w-full">
            <PreventivoTrattamentoSelect
                value={trattamento}
                onChange={(e) => {
                    UpdatePreventivo("17", e);
                }}
            />
        </div>
    );
}



export default PreventivoTrattamento;
